import { truncate, isEmpty } from 'lodash'
import formatTime from '@/utils/time'
import markdown from 'marked'

export function simpleFormat(str) {
  return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
}

export function trunc(string, length = 30) {
  return truncate(string, { length })
}

export function datetime(string) {
  if (isEmpty(string)) {
    return string
  }
  return formatTime(string)
}

export function marked(string) {
  return markdown(string)
}



// WEBPACK FOOTER //
// ./src/utils/filters.js